import { combineReducers } from 'redux'
import { locationReducer } from '../router/router'
import * as gameReducer from './game'
import * as routingReducer from './routing'
import initGameReducer from './initGame.reducer'

export default combineReducers({
    gameInitialised: initGameReducer,
    ...gameReducer,
    ...routingReducer,
    location: locationReducer,
})
